export const isURLActive = (url: string, exact: boolean = false): boolean => {
  const { pathname, hash } = window.location;
  const relevantPart = hash ? hash.replace("#", "") : pathname;
  const activePath = relevantPart.split("?")[0];

  if (exact) {
    return activePath === url || activePath.endsWith(`/${url.replace(/^\//, "")}`);
  }
  return activePath.indexOf(url) !== -1;
};
